import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {oppgraderteAjsTjenester} from "./tjenester/ajs/ajsTjenesteoppgraderinger";
import {AngularHttpKlient} from "felles-ng2/tjenester/ressurser/AngularHttpKlient";
import {httpInterceptorTilbydere} from "felles-ng2/infrastruktur/http/httpInterceptorer";


import {InternasjonaliseringModul} from "felles-ng2/tjenester/i18n/InternasjonaliseringModul";
import {AjsKontekstBro} from "felles-ng2/tjenester/ajs/AjsKontekstBro";
import {appKonfigurasjonProviderInitialisertFraAjs, MILJØProvider} from "felles-ng2/tjenester/Appkonfigurasjon";
import {AksjeeierbokModul} from "web-ng2/moduler/aksjeeierbok/AksjeeierbokModul";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MøteModul} from "web-ng2/moduler/møte/MøteModul";
import {SakModul} from "web-ng2/moduler/sak/SakModul";
import {AksjeklasseModul} from "web-ng2/moduler/aksjeklasse/AksjeklasseModul";
import {LukkMatDialogerVedUtlogging} from "felles-ng2/infrastruktur/material/LukkMatDialogerVedUtlogging";
import {Filehåndtering} from "felles-ng2/infrastruktur/angular/Feilhåndtering";
import {MedlemModul} from "web-ng2/moduler/medlem/MedlemModul";
import {FilvelgerSkytjenesterModul} from "web-ng2/delt/komponenter/filvelger-skytjenester/FilvelgerSkytjenesterModul";
import {KommentarModul} from "web-ng2/moduler/kommentar/KommentarModul";
import {OppgaveModul} from "web-ng2/moduler/oppgave/OppgaveModul";
import {ResetDatalagerVedUtlogging} from "felles-ng2/tjenester/datalager/ResetDatalagerVedUtlogging";
import {GruppeModul} from "web-ng2/moduler/gruppe/GruppeModul";
import {DelteKomponenterModul} from "web-ng2/delt/komponenter/DelteKomponenterModul";
import {AvtaleModul} from "web-ng2/moduler/avtale/AvtaleModul";
import {DatalagerModul} from "felles-ng2/tjenester/datalager/DatalagerModul";
import {BeslutningModul} from "web-ng2/moduler/beslutning/BeslutningModul";
import {PlanModul} from "web-ng2/moduler/plan/PlanModul";
import {MøteprotokollModul} from "web-ng2/moduler/møteprotokoll/MøteprotokollModul";
import {SigneringModul} from "web-ng2/moduler/signering/SigneringModul";
import {MaterialIkonOppsett} from "felles-ng2/infrastruktur/material/MaterialIkonOppsett";
import {AutentiseringModul} from "web-ng2/moduler/autentisering/AutentiseringModul";
import {DokumentModul} from "web-ng2/moduler/dokument/DokumentModul";
import {ArkivModul} from "web-ng2/moduler/arkiv/ArkivModul";
import {SkjermingModul} from "web-ng2/moduler/skjerming/SkjermingModul";
import {DelteDirektiverModul} from "web-ng2/delt/direktiver/DelteDirektiverModul";
import {BrukerModul} from "web-ng2/moduler/bruker/BrukerModul";
import {SpørreundersøkelseModul} from "web-ng2/moduler/spørreundersøkelse/SpørreundersøkelseModul";
import {DashboardModul} from "web-ng2/moduler/dashboard/DashboardModul";
import {ÅrshjulModul} from "web-ng2/moduler/årshjul/ÅrshjulModul";
import {AdministrasjonModul} from "web-ng2/moduler/administrasjon/AdministrasjonModul";
import {AvstemningModul} from "web-ng2/moduler/avstemning/AvstemningModul";

const debug = initDebugger('WebHovedmodulNg2');

@NgModule({
    declarations: [],
    exports: [],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        DatalagerModul,
        InternasjonaliseringModul,
        DelteKomponenterModul,
        DelteDirektiverModul,
        AksjeeierbokModul,
        AksjeklasseModul,
        MøteModul,
        SakModul,
        MedlemModul,
        GruppeModul,
        FilvelgerSkytjenesterModul,
        KommentarModul,
        OppgaveModul,
        AvtaleModul,
        BeslutningModul,
        AvtaleModul,
        PlanModul,
        MøteprotokollModul,
        SigneringModul,
        AutentiseringModul,
        AvtaleModul,
        DokumentModul,
        ArkivModul,
        SkjermingModul,
        BrukerModul,
        SpørreundersøkelseModul,
        DashboardModul,
        ÅrshjulModul,
        AdministrasjonModul,
        AvstemningModul
    ],
    providers: [
        ...oppgraderteAjsTjenester(),
        AngularHttpKlient,
        ...AngularHttpKlient.ng2ServiceProviders(),
        ...httpInterceptorTilbydere,
        [{provide: ErrorHandler, useClass: Filehåndtering}],
        appKonfigurasjonProviderInitialisertFraAjs(),
        MILJØProvider(),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class WebHovedmodulNg2 {

    //den dagen ng2 står for uttegning av initielt vindu legger vi noe lurt inn her
    ngDoBootstrap() {
    }

    constructor(ajsKontekstBro: AjsKontekstBro,
                lukkMatDialogerVedUtlogging: LukkMatDialogerVedUtlogging,
                resetDatalagerVedUtlogging: ResetDatalagerVedUtlogging,
                materialIkonOppsett: MaterialIkonOppsett) {
        ajsKontekstBro.hentAutentisertBrukerFraAjs();
        lukkMatDialogerVedUtlogging.lukkMatDialogerVedUtlogging();
        resetDatalagerVedUtlogging.resetVedUtlogging();
        materialIkonOppsett.brukMaterialSymbols();
    }
}
